﻿import ApiDocumentsDom from "./DocumentsApi.class.dom";
import { Loader } from "@grindex-components/Loader/loader.class";
import { $elementChild } from "@grindex-common/helpers/elements";

export default class DocumentsApi {
	constructor($module, apiUrl) {
		this.$module = $module;
		this.apiUrl = apiUrl;
		const $loader = $elementChild($module, "loader");
		this.loader = new Loader($loader);
	}

	run() {
		this.showSpinner();

		const dom = new ApiDocumentsDom();
		const $container = dom.getContentDiv(this.$module);

		fetch(this.apiUrl, { method: "POST" })
			.then((result) => result.json())
			.then((documents) => {
				if (!documents) {
					return;
				}

				const documentGroups = {};

				documents.forEach((document) => {
					if (!documentGroups[document.documentType]) {
						documentGroups[document.documentType] = [];
					}

					documentGroups[document.documentType].push(document);
				});

				for (const groupName in documentGroups) {
					const group = documentGroups[groupName];

					const $header = dom.createHeader(groupName);

					$container.appendChild($header);

					const $groupContainer = dom.createGroupContainer();

					const $documentsUl = createList(group);

					$groupContainer.appendChild($documentsUl);

					$container.appendChild($groupContainer);
				}
			})
			.catch((error) => {
				throw new Error(`api fetch error, response: ${error}`);
			})
			.finally(() => {
				this.hideSpinner();
			});

		function createList(group) {
			const $ul = document.createElement("ul");

			group.forEach((document) => {
				const $liItem = dom.getDocumentLi(document);
				$ul.appendChild($liItem);
			});

			return $ul;
		}
	}

	hideSpinner() {
		this.loader.hide();
	}

	showSpinner() {
		this.loader.show();
	}
}
